import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { DataVisualizationEmbedEntry } from "frontend/contentful/schema/blocks";
import {
  DataVisualizationEmbed,
  DataVisualizationEmbedProps,
} from "design-system/components/blocks/data-visualization-embed/data-visualization-embed";
import { createComponentHeaderProps } from "../primitives/component-header.props";

interface DataVisualizationOptions {
  headerAbove?: boolean;
}

export const ContentfulDataVisualizationEmbed = createContentfulComponent<
  DataVisualizationEmbedEntry,
  DataVisualizationOptions
>(({ entry, options }) => {
  const headerAbove = options?.headerAbove || false;

  const props: DataVisualizationEmbedProps = {
    header: entry.fields.header
      ? createComponentHeaderProps(entry.fields.header)
      : undefined,
    embedSourceUrl: entry.fields.embedSourceUrl,
    embedSourceTitle: entry.fields.embedSourceTitle,
    height: entry.fields.height,
    align: entry.fields.alignment,
    HeadingLevel: headerAbove ? "h3" : "h2",
  };
  return <DataVisualizationEmbed {...props} />;
});
